import { type Content } from '@/features/cms/components/CMS/types'
import { type ItemList } from 'schema-dts'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { getRetailerUrl } from '@shared/constants/routes'

export const getRetailerShelfSchema = ({
  city,
  canonicalUrl,
  bodyContent,
}: {
  city: string | undefined
  canonicalUrl: string
  bodyContent: Content[]
}): ItemList | undefined => {
  const retailerShelf = bodyContent
    .filter(
      (shelf) =>
        shelf.content_type_id === 'marketing_stores_carousel' ||
        shelf.content_type_id === 'stores_carousel',
    )
    .find((shelf) => shelf.data?.store_cards)

  if (retailerShelf?.data && 'store_cards' in retailerShelf.data) {
    const { id } = getCMSWrapperProps(retailerShelf)

    return {
      '@type': 'ItemList',
      '@id': `${canonicalUrl}#${id}`,
      name: city
        ? `Retailers available for same-day delivery in ${city}`
        : 'Retailers available for same-day delivery',
      itemListElement: retailerShelf.data.store_cards?.map(({ data: retailer }) => ({
        '@type': 'Organization',
        name: retailer.name,
        url: `https://www.shipt.com${getRetailerUrl(retailer.name)}`,
        logo: retailer.logo.src,
      })),
    }
  }
}
